import { imageUrlAppendStyle } from 'contexts/link_util';
import { DetailInstrument, InventoryInstrument } from 'types/drupal/InstrumentNode';

export function instrumentImageUrl(instrument: DetailInstrument, imageStyle: string= '', index: number= 0) {

    // if no images exist on the instrument just return a blank string
    if (instrument.field_instr_image.length <= 0) {
        return '';
    }

    // filename will be the manufacture, model, and year
    const extendedDescriptionRaw = (instrument.field_manufacturer && instrument.field_manufacturer.manufacturer.name)
        + ' ' + (instrument.field_instr_model && instrument.field_instr_model.value)
        + ' ' + (instrument.field_instr_year && instrument.field_instr_year.value)
        + ' ' + (instrument.field_gruhn_category_id && instrument.field_gruhn_category_id.value);

    // trim the extended description to 200 characters to not go over 255 character limit
    const extendedDescription = extendedDescriptionRaw.substring(0, 100);

    // replace all spaces with dashes, strip out unfriendly characters, and append the double dash special character preceding the fid
    const newFileName = extendedDescription.replace(/\//g, ' ').replace(/-/g, ' ').replace(/\s+/g, '-').toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '') + '--' + instrument.field_instr_image[index].file.fid;

    // replace the fid with the new long form fid above
    const newUrl = instrument.field_instr_image[index].file.url.replace(instrument.field_instr_image[index].file.fid.toString(), newFileName);

    // apply image style if necessary
    if (imageStyle) {
        return imageUrlAppendStyle(newUrl, imageStyle);
    }

    return newUrl;
}

export function instrumentImageUrlRef(instrument: InventoryInstrument, imageStyle: string = '') {

    // if no images exist on the instrument just return a blank string
    if (!instrument.field_instr_image_first) {
        return '';
    }

    // filename will be the manufacture, model, and year
    const extendedDescriptionRaw = (instrument.field_manufacturer && instrument.field_manufacturer.manufacturer.name)
        + ' ' + (instrument.field_instr_model && instrument.field_instr_model.value)
        + ' ' + (instrument.field_instr_year && instrument.field_instr_year.value)
        + ' ' + (instrument.field_gruhn_category_id && instrument.field_gruhn_category_id.value);

    // trim the extended description to 200 characters to not go over 255 character limit
    const extendedDescription = extendedDescriptionRaw.substring(0, 100);

    // replace all spaces with dashes, strip out unfriendly characters, and append the double dash special character preceding the fid
    const newFileName = extendedDescription.replace(/\//g, ' ').replace(/-/g, ' ').replace(/\s+/g, '-').toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '') + '--' + instrument.field_instr_image_first.file.fid;

    // replace the fid with the new long form fid above
    const newUrl = instrument.field_instr_image_first.file.url.replace(instrument.field_instr_image_first.file.fid.toString(), newFileName);

    // apply image style if necessary
    if (imageStyle) {
        return imageUrlAppendStyle(newUrl, imageStyle);
    }

    return newUrl;
}

export function instrumentImageAlt(instrument: DetailInstrument, index: number= 0): string {

    // filename will be the manufacture, model, and year
    const extendedDescriptionRaw = (instrument.field_manufacturer && instrument.field_manufacturer.manufacturer.name)
        + ' ' + (instrument.field_instr_model && instrument.field_instr_model.value)
        + ' ' + (instrument.field_instr_year && instrument.field_instr_year.value)
        + ' ' + (instrument.field_gruhn_category_id && instrument.field_gruhn_category_id.value)
        + ' ' + (instrument.field_instr_image && instrument.field_instr_image[index] && instrument.field_instr_image[index].file.filename);

    // trim the extended description to 200 characters to not go over 255 character limit
    const extendedDescription = extendedDescriptionRaw.substring(0, 100);

    return extendedDescription;
}

export function instrumentImageAltRef(instrument: InventoryInstrument): string {

    // filename will be the manufacture, model, and year
    const extendedDescriptionRaw = (instrument.field_manufacturer && instrument.field_manufacturer.manufacturer.name)
    + ' ' + (instrument.field_instr_model && instrument.field_instr_model.value)
    + ' ' + (instrument.field_instr_year && instrument.field_instr_year.value)
    + ' ' + (instrument.field_gruhn_category_id && instrument.field_gruhn_category_id.value)
    + ' ' + (instrument.field_instr_image_first && instrument.field_instr_image_first.file.filename);

    // trim the extended description to 200 characters to not go over 255 character limit
    const extendedDescription = extendedDescriptionRaw.substring(0, 100);

    return extendedDescription;
}



// WEBPACK FOOTER //
// ./src/contexts/instrument.ts